import { createContext, useState, useContext, useEffect } from "react";

const LoginModalContext = createContext();

export const LoginModalProvider = ({ children }) => {
  const [showLogin, setShowLogin] = useState(false);
  const[afterlogin , setAfterLogin]=useState({})
  const [visitPageCount , setVisitPageCount]=useState(()=>{
    const visitCount=localStorage.getItem("visitPageCount")
    return visitCount? parseInt(visitCount,10):0
  })
  const [isForceLogin, setForceLogin]=useState(false)
  const openLogin = (action=null) => {
      setAfterLogin({
     ...action
  })
    setShowLogin(true);
  
   
  };

  const closeLogin = () => {
    setShowLogin(false);
    setAfterLogin(null)
   
  };
  const resetVisitCount = () => {
  setVisitPageCount(0);
  localStorage.setItem("visitPageCount", "0");
  setForceLogin(false);
};
   useEffect(()=>{
    localStorage.setItem("visitPageCount", visitPageCount.toString())
    if(visitPageCount>4)
    {
      setForceLogin(true)
    }
   },[visitPageCount])

  return (
    <LoginModalContext.Provider
      value={{ showLogin, openLogin, closeLogin,afterlogin,setVisitPageCount,visitPageCount,isForceLogin,resetVisitCount}}
    >
      {children}
    </LoginModalContext.Provider>
  );
};

export const useLoginModal = () => useContext(LoginModalContext);
